import Vue from 'vue'
import VueMarkdown from 'vue-markdown'

export default Vue.extend({
  name: 'Markdown',

  props: {
    markdown: {
      type: String as Prop<string>
    }
  },

  components: {
    VueMarkdown
  },

  data () {
    return {
      // https://github.com/miaolz123/vue-markdown#props
      options: {
        html: false,
        typographer: false,
        emoji: false,
        linkify: false
      }
    }
  },

  mounted () {
    this.$el.addEventListener('click', this.handleClick)
  },

  destroyed () {
    this.$el.removeEventListener('click', this.handleClick)
  },

  methods: {
    handleClick (ev: Event) {
      const target = ev.target
      if (!target) {
        return
      }
      const el = target as HTMLElement
      if (el.tagName.toLowerCase() === 'a') {
        // リンク押下時、別タブで開くように
        const a = el as HTMLAnchorElement
        a.target = '_blank'
        a.rel = 'noopener'
      }
    }
  }
})
